import { useQuery } from '@tanstack/react-query';

import {
  getMappedGeography,
  getShuttleProviderGeography,
  getTerritoryConsolidatedGeography,
} from '../queries/getGeography.ts';

export const useTerritoryConsolidatedGeography = (territorySlug: string) => {
  return useQuery({
    queryKey: ['TerritoryConsolidated', territorySlug],
    queryFn: ({ signal }) => getTerritoryConsolidatedGeography(territorySlug, signal),
    retry: false,
  });
};

export const useShuttleProviderGeography = (territorySlug: string) => {
  return useQuery({
    queryKey: ['shuttleProviderGeography', territorySlug],
    queryFn: ({ signal }) => getShuttleProviderGeography(territorySlug, signal),
    retry: false,
  });
};

export const useMappedGeography = (territorySlug: string, territoryIntegrationId: number) => {
  return useQuery({
    queryKey: ['mappedGeography', territorySlug],
    queryFn: ({ signal }) => getMappedGeography(territorySlug, territoryIntegrationId, signal),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
